import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { ClassProvider } from '@angular/core'
import { AppHttpInterceptor } from './http.interceptor'

export const AppHttpInterceptorProvider: ClassProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: AppHttpInterceptor,
    multi: true,
}
